export class Users {
  public static ageCalculator(birthDate: Date): number {
    if (!birthDate) return 0;
    
    const today: Date = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age;
  }
}
